<ng-container *ngIf="editing !== true">
    <button
        class="cmps-icon-button--no-bg"
        cmpsIconButton
        [cmpsTooltipTrigger]="_i18n._11249_DELETE_TASK | translate"
        (click)="$event.stopPropagation(); deleteClick.emit()"
    >
        <cmps-icon svgIcon="trash-can-outline"></cmps-icon>
    </button>
    <button
        class="cmps-icon-button--no-bg"
        cmpsIconButton
        [cmpsTooltipTrigger]="_i18n._11252_EDIT_TASK | translate"
        (click)="$event.stopPropagation(); editClick.emit()"
        *ngIf="canEdit"
    >
        <cmps-icon svgIcon="pencil"></cmps-icon>
    </button>
</ng-container>
<ng-container *ngIf="editing === true">
    <button
        class="cmps-icon-button--no-bg"
        cmpsIconButton
        [cmpsTooltipTrigger]="_i18n._11253_SAVE_TASK | translate"
        (click)="$event.stopPropagation(); saveClick.emit()"
    >
        <cmps-icon svgIcon="content-save-outline"></cmps-icon>
    </button>
    <button
        class="cmps-icon-button--no-bg"
        cmpsIconButton
        [cmpsTooltipTrigger]="_i18n._11254_CANCEL_EDIT | translate"
        (click)="$event.stopPropagation(); cancelEditClick.emit()"
    >
        <cmps-icon svgIcon="close"></cmps-icon>
    </button>
</ng-container>
